<template>
  <div class="ps-skeleton-container">
    <div class="ps-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
    </div>
    <div class="ps-skeleton-container-main">
      <Skeleton height="56px" width="470px" borderRadius="8px" />
      <div class="ps-skeleton-container-main-divider"></div>
      <Skeleton height="84px" width="469px" borderRadius="8px" />
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.ps-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;

  &-header,
  &-main {
    display: flex;
    align-self: stretch;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    align-items: center;
    gap: 16px;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 16px 24px 24px 24px;
    align-items: flex-start;
    gap: 24px;

    &-divider {
      width: 0.5px;
      height: 84px;
      background: $colorD20;
    }
  }
}
</style>
